import type { SVGProps } from 'react';
import { IconBase } from './icon-base';

export function ItalicIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <IconBase {...props}>
      <path d="M19 4h-9" />
      <path d="M14 20H5" />
      <path d="m15 4-6 16" />
    </IconBase>
  );
}
